const discountCode = 'K242MCTZRDE7';
const FREE_GIFT_VARIANT_ID = 44349385998486;
const GIFT_THRESHOLD = 5000;

window.addEventListener("klaviyoForms", function(e) { 
  if (e.detail.type === 'submit') {
    //console.log('klaviyo form submitted');

    // Add discount code to the cookie
    document.cookie = `discount_code=${discountCode}; path=/; max-age=7200`;

    fetch(`/discount/${discountCode}`)
      .then(() => {
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ updates: {} }),
        });
      })
      .then(() => {
        //console.log("discount added");
      })
      .catch(function(error) {
        console.error('Error applying discount:', error);
      });
  }
});

function getCookie(name) {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? decodeURIComponent(match[2]) : null;
}

function addGift() {
    console.log(getCookie('discount_code'));
  if (getCookie('discount_code') !== discountCode){
    //console.log('Discount code not found in cookie');
    return;
  } 

  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const subtotal = cart.items_subtotal_price;
      const hasGift = cart.items.some(item => item.variant_id === FREE_GIFT_VARIANT_ID);

      if (subtotal >= GIFT_THRESHOLD && !hasGift) {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: FREE_GIFT_VARIANT_ID,
            quantity: 1,
          }),
        }
        ).then(() => {
          //console.log('Free gift added');
        }
    );
      }

      if (subtotal < GIFT_THRESHOLD && hasGift) {
        const item = cart.items.find(i => i.variant_id === FREE_GIFT_VARIANT_ID);
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: item.key,
            quantity: 0,
          }),
        });
      }

      return Promise.resolve();
    })
    .then(() => {
      //console.log('Free gift logic executed');
    })
    .catch(err => {
      console.error('Something went wrong with free gift:', err);
    });
}

document.addEventListener('DOMContentLoaded', () => {
  addGift(); // Run on initial load
});

document.addEventListener('rebuy:cart.change', (event) => { 
    //console.log('rebuy:cart.change event', event.detail); 
    addGift(); 
  });
